import { useMediaQuery } from 'react-responsive'
import { Form, Question, CardGridSize } from '@commutifi-fe/ui'
import { Stop } from '@commutifi/modes'

import ActivityCardsSelector from 'shared/components/common/CommuteActivityPicker/components/ActivityCardsSelector'
import { ComposedInputComponentProps } from 'shared/interfaces/Survey'
import { useDeepCompareEffect } from 'shared/hooks/global'
import { dropOffKidsQId } from 'constants/onboarding'
import { screenSizes } from 'constants/global'
import { dropOffOrPickupKidsQuestion } from './customQuestions'

type ActivityMapperProps = ComposedInputComponentProps<string[]>

// +0.5 => make sure it is asked after the secondary commute details if both are in the same sub-section
export const nextSubSection = (section: number): number => Number((section + 0.3).toFixed(1))

function ActivitySelector({ form, question, id, value, upsertQuestions, validation }: ActivityMapperProps) {
  const isXSmall = useMediaQuery({ maxWidth: screenSizes.xsMaxWidth })
  const { getFieldValue } = form
  const activities: string[] = getFieldValue(question.id) || value

  // Add question to know the details about the user commute steps (commute timeline component)
  // when the user has a combined modes commute
  useDeepCompareEffect(() => {
    if (!activities) {
      return
    }
    const section = nextSubSection(question.section)
    // Add a question to the next section when the user answers he uses
    // mixed modes of drive & transit
    const newQuestion = dropOffOrPickupKidsQuestion({
      // Use activity mapper sub component
      id: dropOffKidsQId,
      section,
      referenceKey: null,
      enabled: activities.includes(Stop.DropOffKids),
      conditionalQuestionId: question.id
    })
    upsertQuestions(newQuestion)
  }, [activities, dropOffKidsQId, question])

  return (
    <Form.Item
      name={question.id}
      {...validation}
      label={<Question title={question.content?.title} hint={question.content?.hint} />}
    >
      <ActivityCardsSelector id={id} cardSize={isXSmall ? CardGridSize.Small : CardGridSize.Default}>
        <ActivityCardsSelector.NoActivityOption />
      </ActivityCardsSelector>
    </Form.Item>
  )
}

export default ActivitySelector
